import { GQL_ID } from '@@partner:types:graphql'
import type { StorageContainer, OrderContainer } from '@@partner:types:app'

import { mergeLeft, mergeLeftDropping } from 'merge-left-utils'

export interface StorageContainerFormState extends Omit<StorageContainer, 'id'> {
  id?: GQL_ID
}

export const STORAGE_CONTAINER_DEFAULT_STATE: StorageContainerFormState = {
  id: undefined,
  container_id: '',
  size: '',
  type: '',
  description: '',
  is_active: true,
  next_sanitize_at: undefined,
  sanitization_interval_days: undefined,
  created_at: '',
  updated_at: '',
  displayName: '',
  orderContainers: []
}

export const makeStorageContainerFormState = (container?: StorageContainer): StorageContainerFormState => {
  const state = {
    ...container
  }
  
  return mergeLeft<StorageContainerFormState>(STORAGE_CONTAINER_DEFAULT_STATE, state)
}

export const mapStateToApiVariable = (state: StorageContainerFormState): any =>
  mergeLeftDropping(
    [ 'id', 'displayName', 'orderContainers', 'ordersCount', 'activeOrdersCount', 'created_at', 'updated_at' ],
    STORAGE_CONTAINER_DEFAULT_STATE,
    {
      ...state
    }
  )

export const mapApiDataToState = (data: StorageContainer) => makeStorageContainerFormState(data)
